import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-029c5f41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container flex col" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex align-center" }
const _hoisted_5 = { class: "panel flex align-center" }
const _hoisted_6 = {
  class: "flex",
  style: {"gap":"12px"}
}
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = {
  class: "flex col",
  style: {"align-items":"stretch"}
}
const _hoisted_9 = { class: "panel flex col" }
const _hoisted_10 = { class: "flex justify-between align-center" }
const _hoisted_11 = { class: "text-muted bold" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "flex g6"
}
const _hoisted_14 = { class: "f12 bold" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted flex col g0"
}
const _hoisted_16 = { class: "flex panel" }
const _hoisted_17 = { class: "flex grow col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold text-muted" }, "Pour quel établissement ?"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "bold" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "bold" }
const _hoisted_24 = { class: "panel justify-between align-center" }
const _hoisted_25 = { class: "flex col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold text-muted" }, "Pour quel employées ?"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunicationTargetStore = _resolveComponent("CommunicationTargetStore")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_CommunicationTargetRole = _resolveComponent("CommunicationTargetRole")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeCalendarRanged = _resolveComponent("SeCalendarRanged")!
  const _component_CommunicationStatus = _resolveComponent("CommunicationStatus")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_CommunicationQuiz = _resolveComponent("CommunicationQuiz")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeModal, {
      ref: "storeFilterModal",
      title: "Filters"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CommunicationTargetStore, {
          ref: "targetStore",
          database: _ctx.state.database!
        }, null, 8, ["database"]),
        _createVNode(_component_SeButton, {
          onPress: _ctx.closeStoreFilterModal,
          class: "modal-valid w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "roleFilterModal",
      title: "Filter"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CommunicationTargetRole, {
          ref: "targetRole",
          database: _ctx.state.database!
        }, null, 8, ["database"]),
        _createVNode(_component_SeButton, {
          onPress: _ctx.closeRoleFilterModal,
          class: "modal-valid w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_NavHeader, {
      backButton: "true",
      title: _ctx.state.communication!.name
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeInput, {
            style: {"width":"300px"},
            placeholder: _ctx.Lang.getI18N('name'),
            modelValue: _ctx.state.communication!.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.communication!.name) = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createVNode(_component_SeCalendarRanged, { ref: "calendar" }, null, 512),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CommunicationStatus, {
              communication: _ctx.state.communication!
            }, null, 8, ["communication"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ToggleSwitch, {
            auto: "true",
            modelValue: _ctx.state.communication!.active,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.communication!.active) = $event)),
            ref: "switch"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_SeButton, {
            tooltip: _ctx.Lang.getI18N('save'),
            onPress: _ctx.update,
            ref: "modifyBtn",
            icon: "/ico/save.svg"
          }, null, 8, ["tooltip", "onPress"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Lang.getI18N("attachment")), 1),
              _hoisted_12
            ]),
            _createVNode(_component_WideCard, {
              title: _ctx.Lang.getI18N('attachment'),
              icon: "/ico/file.svg"
            }, {
              subtitle: _withCtx(() => [
                (_ctx.state.communication!.attachment != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.communication!.attachment.name), 1),
                      _createElementVNode("span", _hoisted_14, " (" + _toDisplayString(_ctx.state.communication!.attachment.type) + ")", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              footer: _withCtx(() => [
                (_ctx.state.communication!.attachment != null)
                  ? (_openBlock(), _createBlock(_component_SeFadeButton, {
                      key: 0,
                      onClick: _ctx.downloadAttachment,
                      icon: "/ico/download.svg"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("download")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SeFadeButton, {
                  onClick: _ctx.uploadAttachment,
                  icon: "/ico/upload-blue.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Upload")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["title"]),
            (_ctx.state.communication?.attachment != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_WideCard, {
                title: _ctx.state.communication?.target.stores.length == 0 &&
                _ctx.state.communication?.target.store_tags.length == 0
                ? 'Tout le monde'
                : 'Ciblée'
                ,
                icon: "/ico/filter.svg"
              }, {
                subtitle: _withCtx(() => [
                  (
                    _ctx.state.communication?.target.stores.length == 0 &&
                    _ctx.state.communication?.target.store_tags.length == 0
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Cette communication cible tous les établissements"))
                    : _createCommentVNode("", true),
                  (_ctx.state.communication!.target.stores.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                        _createTextVNode("Cette communication cible "),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.state.communication?.target.stores.length) + " établissement.", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.communication!.target.store_tags.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode("Cette communication cible "),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.state.communication?.target.store_tags.length) + " groupe(s)", 1),
                        _createTextVNode(" d'établissements.")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                footer: _withCtx(() => [
                  _createVNode(_component_SeFadeButton, {
                    onClick: _ctx.openStoreFilterModal,
                    icon: "/ico/edit-blue.svg"
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_WideCard, {
                title: _ctx.state.communication!.target.employee_roles.length == 0 ? 'Tout le monde' : 'Ciblée',
                icon: "/ico/filter.svg"
              }, {
                subtitle: _withCtx(() => [
                  (_ctx.state.communication!.target.employee_roles.length == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Cette communication cible tous les employées"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, [
                        _createTextVNode(" Cette communication cible "),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.state.communication?.target.employee_roles.length) + " role d'employés.", 1)
                      ]))
                ]),
                footer: _withCtx(() => [
                  _createVNode(_component_SeFadeButton, {
                    onClick: _ctx.openRoleFilterModal,
                    icon: "/ico/edit-blue.svg"
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ])
        ]),
        _createVNode(_component_CommunicationQuiz, {
          communication: _ctx.state.communication!
        }, null, 8, ["communication"])
      ])
    ])
  ]))
}